import React, { useState, useEffect } from 'react';
import Modal from '../features/keywords/react/Modal/Modal';
import styles from '../features/keywords/react/Modal/Modal.module.scss';

export default function AlertModal({ message, onClose }) {
  const [Shown, SetShown] = useState(false);

  useEffect(() => {
    SetShown(true);
  }, []);

  const handleClose = () => {
    SetShown(false);
    setTimeout(onClose, 450);
  };

  return (
    <Modal show={Shown} dismissable={true} showClose={false} onClose={handleClose}>
      <div style={{padding: '48px 52px 42px', maxWidth: '600px'}}>
        <div style={{display: 'flex', gap: '20px', alignItems: 'flex-start', marginBottom: '30px'}}>
          <i className="fa-solid fa-circle-info" style={{fontSize: '24px', color: '#4A90E2', marginTop: '2px', flexShrink: 0}}></i>
          <p className={styles.message} style={{margin: 0, fontSize: '16px', lineHeight: '1.6', flex: 1}}>{message}</p>
        </div>
        <div style={{textAlign: 'right'}}>
          <button className='accented-standard' onClick={handleClose} style={{minWidth: '120px'}}>OK</button>
        </div>
      </div>
    </Modal>
  );
}
